import { vk } from 'modules/Services/Access/List/subcomponents/Table/useTableConfig/vk'
import { vkAds } from 'modules/Services/Access/List/subcomponents/Table/useTableConfig/vk-ads'

const map = {
  vk: vk,
  'vk-ads': vkAds,
}

export default map
